import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  item: {
    alignItems: 'center',
    backgroundColor: 'unset',
    borderTop: `solid 1px ${theme.onCardDivider.beige_25_op_30}`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(4)
  }
});

export default makeStyles(styles);
